(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.testimonialSwiper', {
    slidesPerView: 1,
    spaceBetween: 55,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  } catch(e) { console.error(e); }
})();
})();
